'use client';

import { useEffect, useRef, useState } from 'react';
import { useInView, useMotionValue, animate, useReducedMotion } from 'framer-motion';

interface CountUpProps {
  value: number;
  className?: string;
}

export function CountUp({ value, className }: CountUpProps) {
  const reduced = useReducedMotion();
  const ref = useRef<HTMLSpanElement>(null);
  const motionValue = useMotionValue(0);
  const [display, setDisplay] = useState(reduced ? value : 0);
  const inView = useInView(ref, { once: true, margin: '-80px' });

  useEffect(() => {
    if (reduced) {
      setDisplay(value);
      return;
    }
    if (!inView) return;
    const controls = animate(motionValue, value, {
      duration: 1.5,
      ease: 'easeOut',
      onUpdate: (v) => setDisplay(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, reduced, motionValue, value]);

  return (
    <span ref={ref} className={className}>
      {display.toLocaleString('ru-RU')}
    </span>
  );
}
